
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"49","height":"49","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke-linecap":"round"}},[_c('path',{attrs:{"d":"M31.73 25.588v10.2m-15.23-10.2v10.2-10.2zm7.616 0v10.2-10.2z","stroke":"#FFC511"}}),_c('path',{attrs:{"d":"M2.5 21.338h42.308m-36.286-.09l11-12.748m20.282 12.748l-11-12.748M5.884 22.188l2.54 17.85h30.46l2.54-17.85","stroke":"#000"}})])])
          )
        }
      }
    